const getHeaderInformation = (periodDesc: string) => ({
  title: 'Cursos y horarios de matrícula',
  description: `
    Visualiza todos los cursos y horarios disponibles para tu matrícula de ${periodDesc}. La información mostrada, considera
    la aprobación de tus cursos del ciclo actual, caso contrario la oferta variará. Aplica para los alumnos reinscritos y
    reincorporados (no ingresantes).
  `
});

const emptyState = 'Por el momento no hay cursos disponibles';

export { getHeaderInformation, emptyState };
